import React from "react";

import Courses from "../Components/Courses";
import { Helmet } from "react-helmet";

function FeeStructure() {
  return (
		<>
			<Helmet>
				<title>Fee Structure | University of Education</title>
			</Helmet>
			<div className="PageContainer">
				<div className="AdmissionHeader HeaderImg">
					<img src="/Images/Banner/4.jpg" alt="admission-banner" />
				</div>
				<section className="FeeStructureContainer">
					{/* M.Ed. Fee Structure */}
					<div id="Heading" data-aos="fade-up">
						<h1>M.Ed. Fee Structure</h1>
					</div>
					<div className="FeeStructureSection">
						<p data-aos="fade-up">
							The Master of Education (M.Ed.) course has a fee structure as per the University and NTCE norms. 
              The total course fee is approximately ₹85,000 for the one-year program.
						</p>
					</div>
          <section className="FeeStructureTable">
						<table data-aos="fade-up">
							<thead>
								<tr>
									<th>Description</th>
									<th>Amount</th>
								</tr>
							</thead>
							<tr data-aos="fade-up">
								<td>Course Fee (Total)</td>
								<td>Rs. 85,000.00</td>
							</tr>
              <tfoot>
								<tr data-aos="fade-up">
									<td>Note</td>
									<td>Fee must be paid in full at the time of admission.</td>
								</tr>
							</tfoot>
						</table>
					</section>

          <br /><br />

					{/* Integrated B.A.-B.Ed. Fee Structure */}
					<div id="Heading" data-aos="fade-up">
						<h1>Integrated B.A.-B.Ed. Fee Structure</h1>
					</div>
					<div className="FeeStructureSection">
						<p data-aos="fade-up">
							Fee details for the 4-year integrated B.A. B.Ed. / B.Sc. B.Ed. course (Per Semester).
						</p>
					</div>

					<section className="FeeStructureTable">
						<table data-aos="fade-up">
							<thead>
								<tr>
									<th>Category</th>
									<th>Amount (Per Semester)</th>
								</tr>
							</thead>
							<tr data-aos="fade-up">
								<td>General</td>
								<td>Rs. 25,000.00</td>
							</tr>
							<tr data-aos="fade-up">
								<td>OBC</td>
								<td>Rs. 25,000.00</td>
							</tr>
							<tr data-aos="fade-up">
								<td>SC / ST</td>
								<td>Rs. 22,000.00</td>
							</tr>
							<tfoot>
								<tr data-aos="fade-up">
									<td colSpan="2">
                    All fees will be accepted in the form of DD in favour of 'The Registrar, Vinoba Bhave University, Hazaribag' payable at Hazaribag.
                  </td>
								</tr>
							</tfoot>
						</table>
						<article>
							<table data-aos="fade-up">
								<p
									style={{ color: "#0038A3", fontWeight: "600", paddingBottom: "10px" }}
									data-aos="fade-up"
								>
									Prospectus and Application Form Cost
								</p>
								<tr data-aos="fade-up">
									<td>General / OBC (By Cash)</td>
									<td>Rs. 500.00</td>
								</tr>
								<tr data-aos="fade-up">
									<td>General / OBC (By Post)</td>
									<td>Rs. 550.00</td>
								</tr>
								<tr data-aos="fade-up">
									<td>SC / ST (By Cash)</td>
									<td>Rs. 400.00</td>
								</tr>
                <tr data-aos="fade-up">
									<td>SC / ST (By Post)</td>
									<td>Rs. 450.00</td>
								</tr>
							</table>
						</article>
					</section>
				</section>
				<Courses />
			</div>
		</>
	);
}

export default FeeStructure;
